import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AlertService } from '../../alert.service';
import { SmsCallService } from '../sms-call.service';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthorizedRepresentative } from '../sms-call';

@Component({
  selector: 'app-a2p-registration-authorized-representative',
  templateUrl: './a2p-registration-authorized-representative.component.html',
  styleUrls: ['./a2p-registration-authorized-representative.component.css'],
  imports: [ReactiveFormsModule, NgbDropdownModule]
})
export class A2PRegistrationAuthorizedRepresentative implements OnInit {

  // Properties
  @Output() proceedToNextStep: EventEmitter<void> = new EventEmitter<void>();
  @Input() authorizedRepresentative: AuthorizedRepresentative;

  contactPersonForm: FormGroup;
  selectedCountryCode: string = '+1'
  countryCodes: { label: string, value: string }[] = [
    { label: 'US (+1)', value: '+1' }
  ];
  jobPositionValues: { name: string, value: string }[] = [
    {
      "name": "Director",
      "value": "Director"
    },
    {
      "name": "General Manager",
      "value": "GM"
    },
    {
      "name": "Vice President",
      "value": "VP"
    },
    {
      "name": "CEO",
      "value": "CEO"
    },
    {
      "name": "CFO",
      "value": "CFO"
    },
    {
      "name": "General Counsel",
      "value": "General Counsel"
    },
    {
      "name": "Other",
      "value": "Other"
    }
  ];

  // Injections
  private smsCallService = inject(SmsCallService);
  private alertService = inject(AlertService);

  ngOnInit(): void {
    this.contactPersonForm = new FormGroup({
      businessTitle: new FormControl(null, Validators.required),
      email: new FormControl(null, [Validators.required, Validators.email]),
      firstName: new FormControl(null, Validators.required),
      lastName: new FormControl(null, Validators.required),
      jobPosition: new FormControl(null, Validators.required),
      phoneNumber: new FormControl(null, Validators.required)
    });
    if (this.authorizedRepresentative) this.setContactPersonForm();
  }

  // Set Contact Person Form
  private setContactPersonForm(): void {
    this.contactPersonForm.setValue({
      businessTitle: this.authorizedRepresentative.businessTitle,
      email: this.authorizedRepresentative.email,
      firstName: this.authorizedRepresentative.firstName,
      lastName: this.authorizedRepresentative.lastName,
      jobPosition: this.authorizedRepresentative.jobPosition,
      phoneNumber: this.authorizedRepresentative.phoneNumber
    });
    this.selectedCountryCode = this.authorizedRepresentative.phoneNumberCountryCode;
  }

  // Select Country Code
  selectCountryCode(value: string): void {
    this.selectedCountryCode = value;
  }

  // Submit Form
  submitForm(): void {
    if (this.contactPersonForm.valid) {
      const payload = { ...this.contactPersonForm.value }
      if (this.authorizedRepresentative) {
        this.smsCallService.updateAuthorizedRepresentative({
          ...payload,
          phoneNumberCountryCode: this.selectedCountryCode
        }).subscribe(() => {
          this.alertService.showSuccessAlert('Authorized Representative Updated');
          this.proceedToNextStep.emit();
        });
      } else {
        this.smsCallService.createAuthorizedRepresentative({
          ...payload,
          phoneNumberCountryCode: this.selectedCountryCode
        }).subscribe(() => {
          this.alertService.showSuccessAlert('Authorized Representative Saved');
          this.proceedToNextStep.emit();
        });
      }
    } else {
      this.contactPersonForm.markAllAsTouched();
    }
  }

  // Form Accessors
  get businessTitle() { return this.contactPersonForm.controls.businessTitle; }
  get email() { return this.contactPersonForm.controls.email; }
  get firstName() { return this.contactPersonForm.controls.firstName; }
  get lastName() { return this.contactPersonForm.controls.lastName; }
  get jobPosition() { return this.contactPersonForm.controls.jobPosition; }
  get phoneNumber() { return this.contactPersonForm.controls.phoneNumber; }
}
